import { Theme } from "@mui/material";

export const getCardStyles = (theme: Theme) => ({
  minHeight: "fit-content",
  boxSizing: "border-box",
  overflow: "visible",
  boxShadow: theme.customShadows.card,
  border: "none",
  position: "relative",
  borderRadius: "20px",
  padding: { xs: 2, md: 4 },
});
